import { VectorLayerService } from '@nuxtDatakodeUtils/services/vectorLayer.service'
import type { FeatureLike } from 'ol/Feature'
import { Fill, Stroke, Style } from 'ol/style'

type OpportunityData = PildomModules.Voirie.Data.OpportunityData
type LikeData = PildomModules.Voirie.Data.LikeData

// noinspection JSUnusedGlobalSymbols
export class OpportunityVectorLayerService extends VectorLayerService {
    // noinspection JSUnusedGlobalSymbols
    protected highlightOnlyFirst = true // highlight only one feature

    protected fillHighLightedColor: string = '#ff5100ff'
    protected strokeHighLightedColor: string = '#ff5100ff'

    protected fillSelectedColor: string = '#0095ff'
    protected strokeSelectedColor: string = '#0095ff'
    protected editColor = '#0098ff'

    #override
    getPolygonStyle(feature: FeatureLike): Style {
        const myLike: LikeData | null = (feature.getProperties() as OpportunityData).my_like
        const baseColor = this.getColor(myLike) // e.g. '#4CAF50'
        const alpha = myLike === null ? 0.6 : 0.8
        const rgba = this.hexToRgba(baseColor, alpha)
        // exemple style Point
        return new Style({
            fill: new Fill({
                color: rgba,
            }),
            stroke: new Stroke({
                color: baseColor,
                width: 10,
            }),
        })
    }

    private getColor(myLike: LikeData | null): string {
        if (myLike === null) {
            return '#9E9E9E'
        }
        switch (myLike.value) {
            case true:
                return '#4CAF50'
            case false:
                return '#F44336'
            default:
                return '#9E9E9E'
        }
    }

    private hexToRgba(hex: string, alpha: number): string {
        const cleanHex = hex.replace('#', '')
        const bigint = Number.parseInt(cleanHex, 16)

        const r = (bigint >> 16) & 255
        const g = (bigint >> 8) & 255
        const b = bigint & 255

        return `rgba(${r}, ${g}, ${b}, ${alpha})`
    }
}
